<!-- 组件说明 -->
<template>
  <div class="container">
    <el-dialog title="需求登记" :visible.sync="isShow" class="dialog" @close = "close">
      <el-form :model="form" :inline="true"  :rules="rules" ref="needForm">
        <el-form-item label="商品名称" :label-width="formLabelWidth"  prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="批准文号" :label-width="formLabelWidth">
          <el-input v-model="form.wenhao" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="商品规格" :label-width="formLabelWidth"  prop="guige">
          <el-input v-model="form.guige" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="生厂厂家" :label-width="formLabelWidth"  prop="changjia">
          <el-input v-model="form.changjia" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="商品条码" :label-width="formLabelWidth">
          <el-input v-model="form.tiaoma" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="需求数量" :label-width="formLabelWidth"  prop="num">
          <el-input v-model="form.num" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="商品图片"
          :label-width="formLabelWidth"
          class="pic"
        >
          <div class="t-item" v-for="(item, index) in 1">
            <div class="del" v-if="images" @click="delImg(index)">
              <img :src="require('@/assets/images/list_delete@2x.png')" alt="" />
            </div>
            <img
              :src="
                images
                  ? images
                  : require('@/assets/images/icon_uploadpictures.png')
              "
              alt=""
            />
            <input
              :disabled="isInput"
              class="file"
              type="file"
              ref="file"
              @change="selectImg(index)"
              accept="image/png,image/gif,image/jpeg"
            />
          </div>
        </el-form-item>
        <el-form-item label="联系人" :label-width="formLabelWidth">
          <el-input v-model="form.contact" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" :label-width="formLabelWidth">
          <el-input v-model="form.contactway" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth" class="tip">
          <el-input v-model="form.beizhu" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div class="submit" @click="submit">提交需求</div>
      </div>
    </el-dialog>
     <toast ref="toast"></toast>
  </div>
</template>

<script>
//import x from ''
export default {
  props: ["show"],
  components: {},
  data() {
    return {
    isShow:false,
      form: {
        name: "",
        wenhao: "",
        guige: "",
        changjia: "",
        tiaoma: "",
        num: "",
        contact: "",
        contactway: "",
        beizhu:""
      },
      formLabelWidth: "87px",
      isInput: false,
      images: "",
        rules: {
          name: [
            { required: true, message: '请输入商品名称', trigger: 'blur' },
           
          ],
          guige: [
            { required: true, message: '请输入商品规格', trigger: 'blur' }
          ],
          changjia: [
            {required: true, message: '请输入生厂厂家', trigger: 'blur' }
          ],
          num: [
            { required: true, message: '请输入需求数量', trigger: 'blur' }
          ],

        }
    };
  },
  created(){
   
  },
  watch:{
      show:{
          handler(t,f){
              if(t){
                  this.isShow = true
              }
          }
      }

  },
  mounted() {},
  computed: {},
  methods: {
    close() {
        this.isShow = false
        this.$emit("close",this.isShow)
    },
    selectImg(index) {
      let file = this.$refs.file[index].files[0];
      let param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据

      this.$api.POST_UPLOADFILE(param).then((res) => {
       if(res.status)
        if(this.images.length == 0 ){
           this.images = res.data
           this.isInput = true
        }
      });
    },
    delImg(index) {
         this.images = ""
      this.isInput = false
      //console.log(this.images);
    },
    submit(){
      this.$refs.needForm.validate((valid) => {
        //console.log(valid);
          if (!valid) {
            return
          } 
            this.$api.POST_REMANDSAVE({
           goodsName:this.form.name,
           goodsSpecification:this.form.guige,
           manufacturer:this.form.changjia,
           quantity:this.form.num,
           approvalNumber:this.form.wenhao,
           contactInfo:this.form.contactway,
           contactPerson:this.form.contact,
           goodsBarcode:this.form.tiaoma,
           goodsImage:this.images,
           remark:this.beizhu
       }).then(res=>{
         if(res.status){
           this.form.name = '',
           this.form.guige = '',
           this.form.changjia = '',
           this.form.num = '',
           this.form.wenhao = '',
           this.form.contactway = '',
           this.form.contact = '',
           this.form.tiaoma = '',
           this.images = '',
           this.beizhu = ''
            this.$refs.toast.info = {
                 title:'提交成功',
                 type:'success'
               }
               this.$refs.toast.isShow()
            this.isShow = false
         }
           
       })
      })
     
    }
  },

};
</script>

<style lang='scss' scoped>

>>> .el-dialog {
  width: 742px;
  height: 604px;
  border-radius: 10px;
}
>>> .el-dialog__title {
  font-size: 16px;
  color: #333333;
  font-weight: bold;
}
>>> .el-form--inline .el-form-item {
  width: 48%;
}
>>> .el-input__inner {
  width: 240px;
}
>>> .el-form-item__label {
  padding: 0 20px 0 0;
  text-align-last: justify;
}
.pic {
  width: 650px !important;
}
.tip {
  white-space: nowrap;
  >>> .el-input__inner {
    width: 592px;
  }
}
>>> .el-dialog__body {
  padding: 10px 20px;
}
.submit {
  margin: 0 auto;
  width: 400px;
  height: 48px;
  background-color: #fa4b4b;
  border-radius: 4px;
  cursor: pointer;
  @include font(16px, #ffffff, center, 400, 48px);
}
>>> .el-input__inner:focus {
  border: 1px solid #C0C4CC;
}
.t-item {
  position: relative;
  width: 100px;
  height: 100px;
  margin: 0 16px 14px 0;
  cursor: pointer;
  //   background-image: url('../../../../assets/images/icon_uploadpictures.png');
  img {
    @include size(100%, 100%);
  }
  .file {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 10;
  }
  .del {
    position: absolute;
    right: -5px;
    top: -5px;
    z-index: 20;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/main/search/components/goods-need.vue